import gql from "graphql-tag";

export default gql`
	query getPerpetuals {
		getPerpetuals {
			id
			serialNumberID
			serialNumber
			licenseName
			dateCreated
			order {
				orderNumber
				orderDate
				isSerialNumberGenerationPending
			}
			product {
				description
			}
		}
	}
`;

export const readPerpetuals = ({ data }) => data && data.getPerpetuals;
